import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import {NotificationManager} from 'react-notifications';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Paper from 'material-ui/Paper';
import Checkbox from 'material-ui/Checkbox';
import IconButton from 'material-ui/IconButton';
import Tooltip from 'material-ui/Tooltip';
import DeleteIcon from 'material-ui-icons/Delete';
import {post, get} from 'engine/dataServices';
import Button from 'material-ui/Button';
import FilterListIcon from 'material-ui-icons/FilterList';
import Loading from 'app/loading';

const columnData = [
    {id: 'userName', numeric: false, disablePadding: true, label: 'نام کاربری (ثبت کننده نظر)'},
    {id: 'productName', numeric: false, disablePadding: true, label: 'نام محصول'},
    {id: 'comment', numeric: false, disablePadding: true, label: 'خلاصه نظر'},
    {id: 'createDate', numeric: false, disablePadding: true, label: 'تاریخ ثبت'},
];

class EnhancedTableHead extends React.Component {
    static propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const {onSelectAllClick, order, orderBy, numSelected, rowCount} = this.props;

        return (
            <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                        <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                    </TableCell>
                    {columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'default'}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

let EnhancedTableToolbar = props => {
    const {numSelected, selected, parrent} = props;

    const approveBtn = param => async (e) => {
        parrent.handleLoading(true);

        var res = await post('Comment/Approve', param);
;
        switch (res.status) {
            case 200:
                const numSelected = await res.json();
                parrent.loadData();
                parrent.state.selected = [];
                NotificationManager.success(`تعداد ${numSelected} نظر تایید شدند.`, 'عملیات موفق');
                break;
            case 500:
                NotificationManager.error('عملیات با خطا همراه بود.', 'خطا');
                break;
        }

        parrent.handleLoading(false);

    };

    const disApproveBtn = param => async e => {
        parrent.handleLoading(true);

        var res = await post('Comment/DisApprove',param);

        switch (res.status) {
            case 200:
                const numSelected = await res.json();
                parrent.loadData();
                parrent.state.selected = [];
                NotificationManager.success(`تعداد ${numSelected} نظر عدم تایید شدند.`, 'عملیات موفق');
                break;
            case 500:
                NotificationManager.error('عملیات با خطا همراه بود.', 'خطا');
                break;
        }

        parrent.handleLoading(false);
    };


    return (
        <Toolbar
            className={classNames("table-header", {
                ["highlight-light"]: numSelected > 0,
            })}
        >
            <div className="title">
                {numSelected > 0 ? (
                    <div>
                        <Button variant="raised" className="jr-btn bg-success jr-btn-sm text-white"
                                onClick={approveBtn(selected)} style={{marginRight: 10}}>
                            <i className="zmdi zmdi-check zmdi-hc-fw"/>
                            <span>تایید ( {numSelected} مورد انتخاب شده )</span>
                        </Button>
                        <Button variant="raised" className="jr-btn bg-danger jr-btn-sm text-white"
                                onClick={disApproveBtn(selected)}
                                style={{marginRight: 10}}>
                            <i className="zmdi zmdi-close zmdi-hc-fw"/>
                            <span>عدم تایید ( {numSelected} مورد انتخاب شده )</span>
                        </Button>
                    </div>
                ) : (
                    <Typography type="title">نظرات در انتظار تایید کاربران</Typography>
                )}
            </div>
            <div className="spacer"/>
            <div className="actions">
                {/*{numSelected > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon/>
                        </IconButton>
                    </Tooltip>
                ) : (
                    <Tooltip title="Filter list">
                        <IconButton aria-label="Filter list">
                            <FilterListIcon/>
                        </IconButton>
                    </Tooltip>
                )}*/}
            </div>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};


class Producers extends React.Component {
    handleLoading = (status) => {
        this.setState({loading: status})
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({data, order, orderBy});
    };
    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({selected: this.state.data.map(n => n.Mobile)});
            return;
        }
        this.setState({selected: []});
    };
    handleKeyDown = (event, id) => {
        if (keycode(event) === 'space') {
            this.handleClick(event, id);
        }
    };
    handleClick = (event, id) => {
        const {selected} = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({selected: newSelected});
    };
    handleChangePage = (event, page) => {
        this.setState({page});
    };
    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;


    constructor(props, context) {
        super(props, context);

        this.state = {
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            data: [],
            page: 0,
            rowsPerPage: 5,
            loading: true
        };
    }

    componentWillMount(){

        this.loadData();

        this.handleLoading(false);
    }

    async loadData() {
        let response = await get('Comment/GetPendings');
        var data = await response.json();
        this.setState({
            data: data
        });

    }

    render() {
        const {data, order, orderBy, selected, rowsPerPage, page} = this.state;
        return (
            <div>
                {this.state.loading && <Loading/>}
                <Paper>
                    <EnhancedTableToolbar numSelected={selected.length} selected={selected} parrent={this}/>
                    <div className="flex-auto">
                        <div className="table-responsive-material">
                            <Table>
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={this.handleSelectAllClick}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={data.length}
                                />
                                <TableBody>
                                    {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                        const isSelected = this.isSelected(n.Id);
                                        return (
                                            <TableRow
                                                hover
                                                onClick={event => this.handleClick(event, n.Id)}
                                                onKeyDown={event => this.handleKeyDown(event, n.Id)}
                                                role="checkbox"
                                                aria-checked={isSelected}
                                                tabIndex={-1}
                                                key={n.Id}
                                                selected={isSelected}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox checked={isSelected}/>
                                                </TableCell>
                                                <TableCell padding="none">{n.Comment}</TableCell>
                                                <TableCell padding="none">{n.CreatedDate}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            count={data.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    </div>
                </Paper>
            </div>
        );

    }
}

export default Producers;



// WEBPACK FOOTER //
// ./app/routes/toliton/cartable/tabs/comments.js